export function ProfileLinkIcon() {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.50796 2.60449L8.28896 2.60449L8.28896 7.38549L7.47256 7.39083L7.47256 4.00784L3.09175 8.38865L2.5048 7.8017L6.88561 3.42089L3.50796 3.42622V2.60449Z"
        fill="currentColor"
      />
    </svg>
  );
}
